export enum FilterStatus {
    All =1,
    Active,
    Deceased,
    Discharged,
}